import TrackingService from 'app/services/tracking/tracking.service';
import AdminService from "external-services/diary-admin-service/admin.service";
import CustomerUpdateService from "external-services/customer-update-service/customerUpdate.service";
import ObjectCopyService from "external-services/object-copy-service/index";
import PhoneNumberService from 'external-services/phone-number-service/index';

const NS = 'NewCustomerCtrl';

export default function NewCustomerCtrl(
  $scope, $mdDialog, isTouchDevice
) {
  "ngInject";

  TrackingService.trackPageView('cusromer.new');

  const vm = this;

  vm.customer = {
    subscribed: true,
    noShowCount: 0
  };
  vm.displayErrors = false;
  vm.customerValid = true;
  vm.venue = AdminService.getVenue();

  vm.cancel = cancel;
  vm.save = save;

  if (!isTouchDevice) {
    vm.showComplete = true;
  }

  // check couch
  AdminService.restartPeriodicCouchNameCheck(); // restarts the timer
  AdminService.loadVenue(vm.venue.id, true, true).catch(function (err) {
    console.error(err);
  });

  function cancel() {
    $mdDialog.hide();
  }

  function save(isValid) {
    vm.displayErrors = !isValid || !vm.customerValid;
    if (vm.displayErrors) {
      return;
    }

    var tempCustomer = ObjectCopyService.angularSafeCopy(vm.customer);
    tempCustomer = PhoneNumberService.resetPhoneNumberWithTypeValidation(tempCustomer); // Remove country prefix when national number contains special char and a~z A~Z

    vm.saving = true;
    // CustomerUpdateService.add(vm.customer).then(function () {
    CustomerUpdateService.add(tempCustomer).then(function () {
      $mdDialog.hide();
      vm.saving = false;
    }).catch(function () {
      vm.saving = false;
    });
  }
}
